<div class="box-novo-compromisso" *ngIf="showModal" (click)="onBackgroundClick($event)">
  <div class="box-formulario" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-6">
        <h5>Novo Lead</h5>
      </div>
      <div class="col-md-6 text-right" style="padding-top: 5px;">
        <i (click)="fecharModal()" class="fa fa-close"></i>
      </div>
      <hr class="hr-titulo">
      <form [formGroup]="formCadastrar" id="formCadastrar">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="descricao">Descrição</label>
                <input type="text" id="descricao"
                       placeholder="Digite a descrição resumida do atendimento."
                       [ngClass]="{'is-invalid': formCadastrar.get('descricao')?.errors}"
                       formControlName="descricao" class="form-control">
                <span id="descricao-error-required" class="error mensagem-erro"
                      *ngIf="formCadastrar.get('descricao')?.dirty &&
                          formCadastrar.get('descricao')?.errors?.required"
                >A descrição resumida não pode ser vazia <br></span>
                <span id="descricao-error-max-length" class="error mensagem-erro"
                      *ngIf="formCadastrar.get('descricao')?.dirty &&
                          formCadastrar.get('descricao')?.errors?.maxlength"
                >A descrição resumida não pode ser vazia <br></span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="solicitante">Cliente/Empresa</label>
                <select class="form-control" id="solicitante" formControlName="solicitante">
                  <option value="0" disabled selected hidden> Selecione o cliente/empresa</option>
                  <option *ngFor="let item of clientes" value="{{item.id}}">
                    {{item.descricaoTipoDocumento}}: {{item.documento}} - {{item.nome}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="valorPotencial">Valor em potencial</label>
                <input type="text" id="valorPotencial"
                       mask="separator.2"
                       prefix="R$ "
                       thousandSeparator="."
                       decimalMarker=","
                       placeholder="Digite o valor."
                       [ngClass]="{'is-invalid': formCadastrar.get('valorPotencial')?.errors}"
                       formControlName="valorPotencial" class="form-control">
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="status">Status</label>
                <select class="form-control" id="status" formControlName="status"
                        [ngClass]="{'is-invalid': formCadastrar.get('status')?.errors}">
                  <option value="" disabled selected hidden> Selecione o status</option>
                  <option value="0">Contato Inicial</option>
                  <option value="4">Aguardando Cliente</option>
                  <option value="5">Aguardando Assinatura</option>
                  <option value="6">Fechado</option>
                  <option value="7">Agendado</option>
                </select>
                <span id="status-error-required" class="error mensagem-erro"
                      *ngIf="formCadastrar.get('status')?.dirty && formCadastrar.get('status')?.errors?.required">
                  O status é obrigatório <br>
                </span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="descricaoInicial">Notas Rápidas:</label>
                <textarea id="descricaoInicial" class="form-control" rows="5"
                          [ngClass]="{'is-invalid': formCadastrar.get('descricaoInicial')?.errors}"
                          formControlName="descricaoInicial"></textarea>
                <span id="descricaoInicial-error-required" class="error mensagem-erro"
                      *ngIf="formCadastrar.get('descricaoInicial')?.dirty && formCadastrar.get('descricaoInicial')?.errors?.required">
                  As notas rápidas não podem ser vazias <br>
                </span>
                <span id="descricaoInicial-error-max-length" class="error mensagem-erro"
                      *ngIf="formCadastrar.get('descricaoInicial')?.dirty && formCadastrar.get('descricaoInicial')?.errors?.maxlength">
                  As notas rápidas excedem o limite permitido <br>
                </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6" style="padding-top: 10px;margin-top: 20px;">
              <button class="btn btn-warning" (click)="fecharModal()">Cancelar</button>
            </div>
            <div class="col-md-6 pull-right text-right" style="padding-top: 10px;margin-top: 20px;">
              <button class="btn btn-primary" (click)="salvar()">Salvar</button>
            </div>
          </div>
      </form>
    </div>
  </div>
</div>
